import { render, staticRenderFns } from "./appointment-main.vue?vue&type=template&id=3a1b4cf8&scoped=true"
import script from "./appointment-main.vue?vue&type=script&lang=js"
export * from "./appointment-main.vue?vue&type=script&lang=js"
import style0 from "./appointment-main.vue?vue&type=style&index=0&id=3a1b4cf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1b4cf8",
  null
  
)

export default component.exports